import HubSpot from '@clearkit/icons/glyphs/Hubspot';
import Marketo from '@clearkit/icons/glyphs/Marketo';
import Salesforce from '@clearkit/icons/glyphs/Salesforce';
import { CKBox, CKButton } from 'clearkit';
import capitalize from 'lodash/capitalize';
import { useState } from 'react';
import { Link } from 'react-router-dom';

import {
  integrationSubObjectTypes,
  integrationTypeHubSpot,
  integrationTypeMarketo,
  integrationTypeSalesforce,
} from '~/lib/dataEnrichment';

import EnrichmentMetric from './EnrichmentMetric';
import IntegrationStatus from './IntegrationStatus';
import SubObjectIntegrationStatus from './SubObjectIntegrationStatus';

function ActiveIntegrationCard({ accountConnector, queryStartDate }) {
  const [subIntegrationState, setSubIntegrationState] = useState({
    loaded: false,
    data: [],
  });
  const integrationType = accountConnector.service;

  const onSubIntegrationsLoaded = (subIntegrationFieldMappings) => {
    const newSubIntegrationsData = [
      ...subIntegrationState.data,
      subIntegrationFieldMappings,
    ];
    setSubIntegrationState({
      loaded:
        newSubIntegrationsData.length ===
        integrationSubObjectTypes[accountConnector.service].length,
      data: newSubIntegrationsData,
    });
  };

  return (
    <CKBox className="mb-4">
      <div className="flex flex-row items-center p-4 border-b-2 border-gray-200 grow">
        <IntegrationIcon integrationType={integrationType} />
        <div className="flex flex-col ml-2 min-h-12 grow flex-start">
          <div className="text-base font-semibold">
            {capitalize(integrationType)}
          </div>
          <div className="flex flex-row">
            <IntegrationStatus
              accountConnector={accountConnector}
              subIntegrationsData={subIntegrationState.data}
              subIntegrationsLoaded={subIntegrationState.loaded}
            />
          </div>
        </div>
        <div className="flex flex-col p-1 grow">
          <div className="p-2 border-l-2 border-gray-200">
            <EnrichmentMetric
              queryStartDate={queryStartDate}
              clearbitAccountId={accountConnector.accountId}
              externalType={accountConnector.service}
              metricName="unique_records_enriched"
            />
          </div>
        </div>
        <div className="flex-end">
          <ConfigLink integrationType={integrationType} />
        </div>
      </div>
      <div className="flex flex-row items-center p-4 border-b-2 border-gray-200 grow">
        <div className="flex flex-col grow">
          <div className="flex flex-row">
            {integrationSubObjectTypes[integrationType].map((subObjectType) => (
              <SubObjectIntegrationStatus
                onSubIntegrationsLoaded={onSubIntegrationsLoaded}
                key={`${integrationType}-${subObjectType}`}
                accountConnectorId={accountConnector.id}
                subObjectType={subObjectType}
              />
            ))}
          </div>
        </div>
        <div className="flex flex-col flex-end">
          <CKButton
            as={Link}
            to={`/enrichment/${integrationType}/logs`}
            variant="tertiary"
            variantColor="blue">
            View Logs
          </CKButton>
        </div>
      </div>
    </CKBox>
  );
}

function ConfigLink({ integrationType }) {
  const url = `/enrichment/${integrationType}`;
  return (
    <div className="flex flex-col p-1 grow">
      <div className="p-2 border-l-2 border-gray-200">
        <CKButton as={Link} to={url} className="ml-2">
          Configure
        </CKButton>
      </div>
    </div>
  );
}

function IntegrationIcon({ integrationType }) {
  return (
    <CKBox
      className={`flex items-center justify-center w-10 h-12 p-2 bg-${integrationType}`}>
      <IntegrationGlyph integrationType={integrationType} />
    </CKBox>
  );
}
function IntegrationGlyph({ integrationType }) {
  const glyphProps = {
    height: '14',
    width: '14',
    className: 'text-white fill-current',
  };

  switch (integrationType) {
    case integrationTypeSalesforce:
      return <Salesforce {...glyphProps} />;

    case integrationTypeMarketo:
      return <Marketo {...glyphProps} />;
    case integrationTypeHubSpot:
      return <HubSpot {...glyphProps} />;
    default:
      return;
  }
}

export default ActiveIntegrationCard;
